import ItemCardImage from '@/components/GridItemCard/Card/components/ItemCardImage/ItemCardImage';
import styled, { css } from 'styled-components';

export const StyledCardImage = styled.section`
    position: relative;
    aspect-ratio: 1/1;
`;

export const CardImageGrid = styled(ItemCardImage)`
    grid-area: itemimage;

    ${({ theme }) => css`
        @media (max-width: ${theme.breakpoints.tabletNarrowWidth}) {
            img {
                inset: 0;
                position: absolute;
            }
        }
    `}
`;

export const StyledFavoriteButton = styled.span`
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 2;
    @media (max-width: ${({ theme }) => theme.breakpoints.tabletNarrowWidth}) {
        top: 4px;
        right: 5px;
    }
`;
